import React from 'react';

import CommonImage from '@/components/CommonImage';
import CustomDropdown from '@/components/CustomDropdown';
import CustomSelectableDropdown from '@/components/CustomSelectableDropdown';
const CreateDashboardModal = () => {
	// const HEADER_STYLE = [
	// 	{
	// 		id: 'development',
	// 		icon: <SampleDevelopmentIcon />,
	// 		color: '#1C398E',
	// 		bg: '#EFF6FF'
	// 	},
	// 	{
	// 		id: 'order',
	// 		icon: <OrderIcon />,
	// 		color: '#59168B',
	// 		bg: '#FAF5FF'
	// 	},
	// 	{
	// 		id: 'requisition',
	// 		icon: <RequisitionIcon />,
	// 		color: '#312C85',
	// 		bg: '#EEF2FF'
	// 	},
	// 	{
	// 		id: 'sales',
	// 		icon: <SalesIcon />,
	// 		color: '#104E64',
	// 		bg: '#ECFEFF'
	// 	},
	// 	{
	// 		id: 'costing',
	// 		icon: <CostingIcon />,
	// 		color: '#0D542B',
	// 		bg: '#F0FDF4'
	// 	},
	// 	{
	// 		id: 'issue',
	// 		icon: <IssueIcon />,
	// 		color: '#82181A',
	// 		bg: '#FEF2F2'
	// 	},
	// 	{
	// 		id: 'buyer-request',
	// 		icon: <BuyerRequestIcon />,
	// 		color: '#7E2A0C',
	// 		bg: '#FFF7ED'
	// 	},
	// 	{
	// 		id: 'others',
	// 		icon: <OthersIcon />,
	// 		color: '#222222',
	// 		bg: '#F0F0F0'
	// 	}
	// ];
	return (
		<div className="popup-wrapper">
			<div className="common-popup create-dashboard-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Create dashboard</h3>
					</div>
					<div className="close-btn">
						<img alt="close" src=" /icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Card title</label>
								<input type="text" placeholder="Write the card name" />
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group no-shadow-react-select">
								<label htmlFor="collection">List item</label>
								<CustomSelectableDropdown
									title="Select card title"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Card header section styling</label>
								<div className="select-component">
									<div className="click-box click mb-1" data-toggle="dropdown">
										<p className="regular-14 ">select</p>
										<img src=" /images/chevron_down.svg" />
									</div>
									<div className="dropdown-box dropdown-menu section-styling-dropdown">
										<div className="list-items scroll-y-label">
											<div className="single-item sample-development">
												<div
													className="d-flex align-items-center"
													style={{ backgroundColor: '#EFF6FF' }}
												>
													<span className="icon" style={{ color: '#5E5EFB' }}>
														<CommonImage src="/icons/dashboard/sample-development.svg" />
													</span>
													<p className="text" style={{ color: '#5E5EFB' }}>
														Sample development
													</p>
												</div>
											</div>
											<div
												className="single-item order d-flex align-items-center"
												style={{ backgroundColor: '#FAF5FF' }}
											>
												<span className="icon" style={{ color: '#AA5BF8' }}>
													<CommonImage src="/icons/dashboard/order.svg" />
												</span>
												<p className="text" style={{ color: '#AA5BF8' }}>
													Order
												</p>
											</div>
											<div
												className="single-item requisition d-flex align-items-center"
												style={{ backgroundColor: '#EEF2FF' }}
											>
												<span className="icon" style={{ color: '#5E5EFB' }}>
													<CommonImage src="/icons/dashboard/requisition.svg" />
												</span>
												<p className="text" style={{ color: '#5E5EFB' }}>
													Requisition
												</p>
											</div>
											<div
												className="single-item sales d-flex align-items-center"
												style={{ backgroundColor: '#ECFEFF' }}
											>
												<span className="icon" style={{ color: '#52BEAE' }}>
													<CommonImage src="/icons/dashboard/sales.svg" />
												</span>
												<p className="text" style={{ color: '#52BEAE' }}>
													Sales
												</p>
											</div>
											<div
												className="single-item costing d-flex align-items-center"
												style={{ backgroundColor: '#F0FDF4' }}
											>
												<span className="icon" style={{ color: '#52BE52' }}>
													<CommonImage src="/icons/dashboard/costing.svg" />
												</span>
												<p className="text" style={{ color: '#52BE52' }}>
													Costing
												</p>
											</div>
											<div
												className="single-item issue d-flex align-items-center"
												style={{ backgroundColor: '#FEF2F2' }}
											>
												<span className="icon" style={{ color: '#FFF7ED' }}>
													<CommonImage src="/icons/dashboard/issue.svg" />
												</span>
												<p className="text" style={{ color: '#E25858' }}>
													Issue
												</p>
											</div>
											<div
												className="single-item buyer-request d-flex align-items-center"
												style={{ backgroundColor: '#FFF7ED' }}
											>
												<span className="icon" style={{ color: '#E29E58' }}>
													<CommonImage src="/icons/dashboard/buyer.svg" />
												</span>
												<p className="text" style={{ color: '#E29E58' }}>
													Buyer request
												</p>
											</div>
											<div
												className="single-item others d-flex align-items-center"
												style={{ backgroundColor: '#F0F0F0' }}
											>
												<span className="icon">
													<CommonImage src="/icons/dashboard/other.svg" />
												</span>
												<p style={{ color: '#4A4A4A' }}>Others</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Section</label>
								<CustomDropdown
									title="Section"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Description</label>
								<textarea name="" id="" placeholder="Description" />
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateDashboardModal;
